export const ACTIONS_CONSTANTS = {
  delete: 'Delete',
  cancel: 'Cancel',
  open: 'Open',
  close: 'Close',
};
